// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__RrBVa","menuItem":"Menu_menuItem__32r1m"};